import { render, staticRenderFns } from "./EventReminder.vue?vue&type=template&id=13459074&"
import script from "./EventReminder.vue?vue&type=script&lang=js&"
export * from "./EventReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports